import React from "react";
import { NavLink } from "react-router-dom";
import { Breadcrumbs } from "react-breadcrumbs-dynamic";
import { withTheme } from "@material-ui/core/styles";

function OSSBreadcrumbs({ theme }) {
  const fontFamily = theme.typography.fontFamily;
  const fontSize = theme.typography.pxToRem(14);
  const color = theme.palette.text.primary;

  const stripQueryString = (url = "") => url.split("?")[0];

  const sortBreadcrumbs = (a, b) => {
    const strippedA = stripQueryString(a.to);
    const strippedB = stripQueryString(b.to);

    return strippedA - strippedB;
  };

  return (
    <Breadcrumbs
      compare={(a, b) => sortBreadcrumbs(a, b)}
      separator={<strong>{">"} </strong>}
      item={NavLink}
      finalItem={"span"}
      finalProps={{
        style: {
          fontWeight: 600,
          fontFamily: fontFamily,
          fontSize,
          textDecoration: "none",
          color: color
        }
      }}
    />
  );
}

export default withTheme(OSSBreadcrumbs);
